export default "__VITE_ASSET__GoyxDjC3__"